import React from 'react';

/**
 * Shared "captioned field" chrome (deepcontext-mfoi): the 10px uppercase
 * accent caption with its 5px dot, plus the accent-bordered resting classes
 * for the trigger below it. Originally lived only in AnalysisProfileSelect's
 * `captioned` mode (deepcontext-tpe1, "Blueprint"); Market's header-row
 * selector (deepcontext-mfoi) now shares the exact same look, so both live
 * here instead of drifting apart as separate copies.
 */
export const CAPTIONED_TRIGGER_RESTING_CLASSES =
  'border-[1.5px] border-accent dark:border dark:border-[rgba(194,155,255,0.45)] bg-surface shadow-sm dark:shadow-none dark:bg-[rgba(194,155,255,0.07)]';

export const CaptionLabel: React.FC<{ label: string }> = ({ label }) => (
  <div className="flex items-center gap-[7px] pl-1.5 mb-[7px] text-[10px] font-bold uppercase leading-none tracking-[.14em] text-accent-active dark:text-accent">
    <span className="w-[5px] h-[5px] rounded-full bg-current flex-shrink-0" />
    {label}
  </div>
);
